import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import content from './locale/content'
import vSelect from 'vue-select'
import VueGtm from '@gtm-support/vue2-gtm'
import './plugins/vee-validate';

Vue.config.productionTip = false;

// axios.defaults.baseURL = 'https://magazynpismo.pl';
Vue.prototype.$http = axios;
Vue.prototype.$appInfo = window.APP_INFO;
Vue.prototype.$digitalPlans = window.APP_INFO.init.subscription_groups['wydanie-cyfrowe'];
Vue.prototype.$paperPlans = window.APP_INFO.init.subscription_groups['wydanie-cyfrowe-i-papierowe'];
Vue.prototype.$specialPlans = window.APP_INFO.init.subscription_groups['plakaty'];
Vue.prototype.$content = content;

Vue.component('v-select', vSelect);

Vue.use(VueGtm, {
  id: "GTM-M4DMWSR",
  defer: false,
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
